import { Box, Button, Divider, Grid, Typography } from '@mui/material';

import FormProvider from 'common/components/form-provider';
import React from 'react';
import { useForm } from 'react-hook-form';
import ImgVnpay from 'assets/images/icons/campaign-data-collection/payment-vnpay.jpg';
import { toast } from 'react-toastify';
import { useAppSelector } from 'common/hook';
import { RootState } from 'plugins/store';
import { CreatePayment } from 'services/payment.service';
import { handleError } from 'utils/helpers';
interface ITabPaymentProps {
    tabIndex: number;
}
const TabPayment: React.FC<ITabPaymentProps> = () => {
    const surveyPayment = useAppSelector(
        (state: RootState) => state.payment.surveyPayment
    );
    const methods = useForm({
        mode: 'onChange',
    });
    const { handleSubmit } = methods;

    const onSubmit = handleSubmit(async () => {
        if (!surveyPayment.product_id) {
            toast.error('Hãy hoàn thành bước 1 trước');
            return;
        }
        try {
            const payment_target_payload = {
                dob: surveyPayment.payment_target.dob,
                gender: surveyPayment.payment_target.gender,
                address: surveyPayment.payment_target.address,
                marriage: surveyPayment.payment_target.marriage,
                child: surveyPayment.payment_target.child,
                career: surveyPayment.payment_target.career,
                career_field: surveyPayment.payment_target.career_field,
                monthly_personal_income:
                    surveyPayment.payment_target.monthly_personal_income,
                monthly_family_income:
                    surveyPayment.payment_target.monthly_family_income,
            };
            const payload = {
                payment: {
                    product_type: surveyPayment.product_type,
                    product_id:
                        surveyPayment.product_type === 'Plan'
                            ? surveyPayment.product_id
                            : surveyPayment.campaign?.value,
                    total_answer: surveyPayment.costInfo.number_of_answer,
                    client_id: surveyPayment.client_id,
                    client_company_name: surveyPayment.invoiceInfo.companyName,
                    client_tax_number: surveyPayment.invoiceInfo.taxCode,
                    client_company_address: surveyPayment.invoiceInfo.address,
                    client_name: surveyPayment.invoiceInfo.invoiceRecipient,
                    client_phone: surveyPayment.invoiceInfo.phone,
                    client_email: surveyPayment.invoiceInfo.email,
                    payment_target: payment_target_payload,
                },
            };
            const response = await CreatePayment(payload);
            if (response.success) {
                toast.success('Tạo thanh toán thành công');
                const responseAttributes = response.data.payment.attributes;
                if (responseAttributes) {
                    console.log(responseAttributes);
                    window.open(responseAttributes.url_payment, '_blank');
                    localStorage.setItem(
                        'urlCallback',
                        `/admin/payment/${responseAttributes.id}/result`
                    );
                }
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            handleError(error);
        }
    });

    return (
        <Box sx={{ mt: 3, mb: 3 }}>
            <FormProvider methods={methods} onSubmit={onSubmit}>
                <Grid container spacing={11}>
                    <Grid item xs={7}>
                        <Typography
                            variant="h5"
                            sx={{
                                fontWeight: 600,
                                fontSize: '30px',
                                lineHeight: '36px',
                                marginBottom: '26px',
                            }}
                        >
                            Chọn phương thức thanh toán
                        </Typography>
                        <img
                            src={ImgVnpay}
                            alt="vnpay"
                            style={{
                                borderRadius: '30px',
                            }}
                        />
                        <Typography
                            variant="body2"
                            sx={{
                                fontSize: '20px',
                                lineHeight: '28px',
                                fontWeight: 300,
                                marginTop: '44px',
                                fontStyle: 'italic',
                            }}
                        >
                            Nhấn nút Thanh toán bên phải, bạn sẽ được chuyển đến
                            công thanh toán trực tuyến của VNPAY - Đối tác thanh
                            toán của Surveytrue.vn. Tại đây giao dịch của bạn sẽ
                            được bảo vệ một cách an toàn nhất. Khảo sát của bạn
                            sẽ được hệ thống tự động kích hoạt ngay sau khi
                            thanh toán thành công.
                        </Typography>
                    </Grid>
                    <Grid item xs={5}>
                        <>
                            <Typography
                                variant="h5"
                                sx={{
                                    fontWeight: 700,
                                    fontSize: '30px',
                                    lineHeight: '60.51px',
                                }}
                            >
                                Hóa đơn
                            </Typography>
                            <Divider
                                sx={{
                                    borderTop: '2px dashed #000',
                                    margin: '20px 0px 30px 0px',
                                }}
                            />
                            <Typography
                                variant="h4"
                                sx={{
                                    fontSize: '40px',
                                    fontWeight: 600,
                                    lineHeight: '35px',
                                    marginBottom: '12px',
                                }}
                            >
                                {surveyPayment.costInfo.total_price_text}
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    fontSize: '24px',
                                    lineHeight: '35px',
                                    fontWeight: 400,
                                    marginBottom: '43px',
                                }}
                            >
                                Tổng chi phí VND
                            </Typography>
                            <Box>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    sx={{
                                        width: '100%',
                                        marginBottom: '39px',
                                        minHeight: '60px',
                                        borderRadius: '60px',
                                        fontSize: '24px',
                                        textTransform: 'none',
                                        fontWeight: 700,
                                    }}
                                >
                                    Xác nhận
                                </Button>
                            </Box>
                            <Box>
                                <Typography
                                    variant="h5"
                                    sx={{
                                        fontSize: '30px',
                                        fontWeight: 600,
                                        lineHeight: '25px',
                                        marginBottom: '12px',
                                    }}
                                >
                                    Ngày hoàn thành
                                </Typography>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontSize: '18.46px',
                                        fontWeight: 400,
                                        lineHeight: '18.46px',
                                        marginBottom: '59px',
                                        color: '#000000B2',
                                    }}
                                >
                                    {surveyPayment.costInfo.date_payment}
                                </Typography>
                            </Box>
                            <Typography
                                variant="h5"
                                sx={{
                                    fontSize: '30px',
                                    fontWeight: 600,
                                    lineHeight: '25px',
                                    marginBottom: '24px',
                                }}
                            >
                                Chi tiết
                            </Typography>
                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(2, 1fr)',
                                    gap: 3,
                                }}
                            >
                                {[
                                    {
                                        label: 'Tổng tiền',
                                        value: surveyPayment.costInfo
                                            .price_before_discount_text,
                                    },
                                    {
                                        label: 'Chiết khấu',
                                        value: surveyPayment.costInfo
                                            .discount_text,
                                    },
                                    {
                                        label: 'Tổng chi phí trước thuế',
                                        value: surveyPayment.costInfo
                                            .price_before_tax_text,
                                    },
                                    {
                                        label: 'VAT (10%)',
                                        value: surveyPayment.costInfo.tax_text,
                                    },
                                ].map((item, index) => (
                                    <React.Fragment key={index}>
                                        <Box
                                            sx={{
                                                fontSize: '24px',
                                                fontWeight: 400,
                                                lineHeight: '29.05px',
                                                color: '#000000B2',
                                            }}
                                        >
                                            {item.label}
                                        </Box>
                                        <Box
                                            sx={{
                                                fontSize: '24px',
                                                fontWeight: 400,
                                                lineHeight: '29.05px',
                                                color: '#000000B2',
                                                textAlign: 'right',
                                            }}
                                        >
                                            {item.value}
                                        </Box>
                                    </React.Fragment>
                                ))}
                            </Box>
                        </>
                    </Grid>
                </Grid>
            </FormProvider>
        </Box>
    );
};

export default TabPayment;
